import { action } from '@ember/object';
import { service } from '@ember/service';
import Component from '@glimmer/component';
import TeamValidations from 'scaleflow/validators/team';

export default class QuickAddsTeamComponent extends Component {
  @service store;
  @service router;
  team = {
    name: '',
  };
  teamValidations = TeamValidations;

  @action
  async onSubmit(changeset, e) {
    e.preventDefault();
    try {
      await changeset.validate();
      if (changeset.isInvalid) {
        console.debug(changeset.errors);
        return;
      }
      const team = this.store.createRecord('team', {
        name: changeset.name,
      });
      await team.save();
      await this.args?.onItemSaved(team);
      this.handleModalDismiss();
    } catch (err) {
      console.log(err);
    }
  }

  @action
  handleModalDismiss() {
    this.args?.handleFormDismiss();
  }
}
